export default __webpack_public_path__ + "static/media/mentor.1644d0fe.png";